import OrderDatatable from "./order_datatable_controller";

// Connects to data-controller="home-order-datatable"
export default class extends OrderDatatable {
  // Recent-orders preview cap. serverSide:true + a small pageLength means the
  // server only ever returns this many rows (the pager is hidden via
  // show-pagination-value="false"), so pageLength IS the desktop row cap.
  // Data-driven (data-home-order-datatable-page-length-value) so the org-level
  // dashboard widget can cap at 5 while the per-event dashboard preview keeps 4
  // (the default) — no separate controller needed. Stimulus merges this with the
  // ancestor values automatically.
  static values = { pageLength: { type: Number, default: 4 } };

  get pageLength() {
    return this.pageLengthValue;
  }

  get searching() {
    return false;
  }
}
